<template>
  <hi-dialog
    :submitDisabled="!valid || !project"
    v-model="isOpen"
    @submit="submit"
    width="800px"
    title="Add New Leads"
  >
    <v-form v-model="valid" ref="form">
      <v-container>
        <v-row>
          <v-col cols="4">
            <v-text-field
              v-model="name"
              :rules="nameRules"
              label="First name"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="midName" label="Middle name"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="surname" label="Surname"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="8">
            <v-text-field
              v-model="email"
              :rules="emailRules"
              label="E-mail"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="phone"
              :rules="phoneRules"
              label="Phone number"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <v-text-field
              v-model="priceMin"
              label="Budget min"
              type="number"
              suffix="MIL"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="priceMax"
              label="Budget max"
              type="number"
              suffix="MIL"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="bed"
              label="Bedroom"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="postcode"
              label="Postcode"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-select
              v-model="project"
              :items="projects"
              item-text="label"
              item-value="value"
              label="Project"
              required
            ></v-select>
          </v-col>
          <v-col cols="6">
            <v-select
              label="Source"
              v-model="source"
              :items="sources"
              item-text="label"
              item-value="value"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="error">{{ error }}</v-row>
      </v-container>
    </v-form>
  </hi-dialog>

  <!--        <v-btn color="primary" text @click="close">Close</v-btn>-->
  <!--        <v-btn color="primary" text @click="submit">Submit</v-btn>-->
</template>
<script>
import { meta } from "@/db";
import { api } from "@/api";
import HiDialog from "@/components/HiDialog";
import Validator from "@/hive/Validator";

export default {
  components: {
    HiDialog
  },
  data() {
    return {
      isOpen: false,
      valid: false,
      name: "",
      midName: "",
      surname: "",
      phone: "",
      email: "",
      project: null,
      source: null,
      postcode: "",
      priceMin: null,
      priceMax: null,
      bed: null,
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length > 1) || "Name must be valid"
      ],
      emailRules: [v => Validator.email(v) || "Email must be valid"],
      phoneRules: [
        v => !v || Validator.phoneNumber(v) || "Phone number must be valid."
      ],
      projects: [],
      sources: null,
      error: null
    };
  },
  async created() {
    this.projects = await meta.projects();
    this.sources = await meta.sources();
  },

  methods: {
    open() {
      this.isOpen = true;
    },
    clearForm() {
      const project = this.project.toString();
      // console.log(project);
      this.$refs.form.reset();
      this.error = null;
      this.project = project; //this doesn't work

      // this.name = "";
      // this.midName = "";
      // this.surname = "";
      // this.email = "";
      // this.phone = "";
      // this.postcode = "";
      // // this.project = null;
      // this.priceMin = null;
      // this.priceMax = null;
      // this.source = null;
      // this.bed = null;
    },
    submit() {
      const data = {
        name: this.name,
        gender: 1,
        midName: this.midName,
        surname: this.surname,
        project: this.project,
        email: this.email,
        phone: this.phone,
        postcode: this.postcode,
        budget: [this.priceMin, this.priceMax],
        source: this.source,
        type: "MAN"
      };
      // console.log(data);
      if (!this.project) {
        this.error = "Project must be provided!";
        return;
      }
      api.leads
        .leadsAdd(data)
        .then(() => {
          this.clearForm();
          this.isOpen = false;
        })
        .catch(error => {
          console.log(error);
          this.error = error;
        });
    }
  }
};
</script>
<style lang="scss" scoped></style>
